import { useMemo } from "react"
import { BAND_HEIGHT, BAND_TOTAL_HEIGHT, BandProps } from "./Band"
import { useDimensionsContext } from "./DimensionsProvider"

const BAND_WIDTH = 86
const BAND_ROUNDNESS = 4

export const NoDataBand = ({ index }: Pick<BandProps, "index">) => {
  const { boundedHeight, boundedWidth } = useDimensionsContext()

  const basePosition = boundedHeight

  const YPos = useMemo(() => basePosition - BAND_TOTAL_HEIGHT * (index + 1), [index, basePosition])
  const XPos = useMemo(() => boundedWidth / 2 - BAND_WIDTH / 2, [boundedWidth])

  return (
    <g>
      <rect
        width={BAND_WIDTH}
        height={BAND_HEIGHT}
        y={YPos}
        x={XPos}
        rx={BAND_ROUNDNESS}
        ry={BAND_ROUNDNESS}
        style={{ stroke: "#a3a3a3", fill: "white" }}
      />
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        y={YPos + 9}
        x={XPos + 8}
      >
        <path
          d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
          stroke="#171717"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
        <path
          d="M12 7.5V12.75"
          stroke="#171717"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 17.25C12.6213 17.25 13.125 16.7463 13.125 16.125C13.125 15.5037 12.6213 15 12 15C11.3787 15 10.875 15.5037 10.875 16.125C10.875 16.7463 11.3787 17.25 12 17.25Z"
          fill="#171717"
        />
      </svg>
      <text y={YPos + BAND_HEIGHT / 1.5} x={XPos + 30} className="text-xs">
        No data
      </text>
    </g>
  )
}
